import { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { ExternalLink, Gift } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';
import api from '../lib/api';
import { toast } from 'sonner';

const Affiliates = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadProducts(); }, []);

  const loadProducts = async () => {
    try { const r = await api.get('/affiliates'); setProducts(r.data); }
    catch { toast.error('Failed to load products'); }
    finally { setLoading(false); }
  };

  if (loading) {
    return <DashboardLayout title="RECOMMENDED PRODUCTS"><div className="flex items-center justify-center py-32"><div className="w-16 h-16 border-4 border-[#FF6B6B] border-t-transparent rounded-full animate-spin"></div></div></DashboardLayout>;
  }

  return (
    <DashboardLayout title="RECOMMENDED PRODUCTS">
      <div className="bg-[#1B4332] rounded-2xl p-6 mb-8 flex items-center gap-4">
        <div className="w-12 h-12 bg-[#BFDB38] rounded-xl flex items-center justify-center">
          <Gift className="w-6 h-6 text-[#1B4332]" strokeWidth={2.5} />
        </div>
        <div>
          <h2 className="text-lg font-black text-white" style={{ fontFamily: 'Nunito, sans-serif' }}>TOP-RATED CAT FOODS</h2>
          <p className="text-sm text-white/60">Premium nutrition recommended by PurrCheck AI</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <div key={product.id} className="bg-white border-2 border-[#1B4332]/8 rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`product-${product.id}`}>
            <div className="aspect-square overflow-hidden bg-gradient-to-br from-[#1B4332]/5 to-[#BFDB38]/5">
              <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-5">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <h3 className="text-lg font-black text-[#1B4332] mb-0.5" style={{ fontFamily: 'Nunito, sans-serif' }}>{product.name}</h3>
                  <p className="text-xs text-[#1B4332]/50 uppercase tracking-wide font-bold">{product.brand}</p>
                </div>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-lg font-black ${product.grade === 'A' ? 'bg-[#BFDB38] text-[#1B4332]' : 'bg-[#BFDB38]/60 text-[#1B4332]'}`}>{product.grade}</div>
              </div>
              <p className="text-sm text-[#1B4332]/70 mb-4">{product.description}</p>
              <div className="flex items-center justify-between">
                <p className="text-2xl font-black text-[#FF6B6B]" style={{ fontFamily: 'Nunito, sans-serif' }}>{product.price}</p>
                <Button onClick={() => window.open(product.affiliate_url, '_blank')} className="rounded-full font-bold bg-[#1B4332] hover:bg-[#1B4332]/90 text-sm" data-testid={`buy-${product.id}`}>
                  View <ExternalLink className="w-3.5 h-3.5 ml-1.5" strokeWidth={2.5} />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 bg-[#1B4332]/5 border-2 border-[#1B4332]/8 rounded-2xl p-5 text-center">
        <p className="text-xs text-[#1B4332]/50 uppercase tracking-wider font-bold">
          Affiliate links - PurrCheck may earn a commission at no extra cost to you
        </p>
      </div>
    </DashboardLayout>
  );
};

export default Affiliates;
